import React, { ComponentProps, Children, useMemo, cloneElement } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './CardListItem.module.css';
import { CardListItemInfo, WrappedCardListItemSubComponentElement } from './cardListItemSubComponent';
export enum CardListItemSize {
  Normal = 'normal',
  Small = 'small',
}
export type CardListItemProps = ComponentProps<'div'> & {
  /**
   * default Normal
   */
  readonly size?: CardListItemSize;
  readonly children?: Array<WrappedCardListItemSubComponentElement | null | undefined> | WrappedCardListItemSubComponentElement;
  /**
   * default: false
   */
  readonly inline?: boolean;
};

/**
 * these classes set a --card-list-item-height css var so you can style your components appropiately
 */
export const cardListItemSizeToHeightClassName: Record<CardListItemSize, string> = {
  normal: styles.cardListItemHeightNormal,
  small: styles.cardListItemHeightSmall
};
export const CardListItem = React.memo<CardListItemProps>(props => {
  const {
    children = [],
    className,
    size = CardListItemSize.Normal,
    inline = false,
    ref,
    ...remainingProps
  } = prepareProps({
    props
  });
  const cardListItemInfo: CardListItemInfo = useMemo(() => ({
    size
  }), [size]);
  return <div {...remainingProps} className={classes(className, styles.wrapper, cardListItemSizeToHeightClassName[size], inline ? styles.wrapperInline : null)} ref={ref}>
      {Children.map(children, (c, index) => {
      // only pass values to custom elements
      if (c == null || typeof c.type === 'string') {
        return c;
      }
      return cloneElement<{
        cardListItemInfo: CardListItemInfo;
      }>(c, {
        cardListItemInfo,
        key: c.key ? c.key : `card-list-item-child-index-${index}`
      });
    })}
    </div>;
});